import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Empty, Select, Spin, TreeSelect} from 'antd';
import type {SelectProps} from 'antd';
import {debounce, isEmpty} from "lodash-es";

export interface DebounceSelectProps<ValueType = any>
    extends Omit<SelectProps<ValueType | ValueType[]>, 'options' | 'children'> {
  fetchOptions: (search: Record<string, any>) => Promise<ValueType[]>;
  debounceTimeout?: number;
  label?: string; // 搜索框 提示文案：请搜索选择label
  isCommon?: boolean;
  readOnly?: boolean;
  pageSize?: number;
  enabled?: boolean | null;
  nameKey?: string; // 搜索Key
  query?: Record<string, any> // 回显查询参数
  fixedParams?: Record<string, any> // 其他固定查询参数
  resDataIsArray?: boolean; // 返回数据是否是数组
}

function DebounceSelect<
    ValueType extends { key?: string; label: React.ReactNode; } = any,
>({
    fetchOptions,
    debounceTimeout = 800,
    label,
    isCommon = false,
    query = {},
    fixedParams = {},
    nameKey = 'nameKey',
    fieldNames,
    enabled = true,
    resDataIsArray,
    ...props
  }: DebounceSelectProps<ValueType>) {
  const [fetching, setFetching] = useState(false);
  const [isReload, setIsReload] = useState(false);
  const [options, setOptions] = useState<any>([]);
  const [params] = useState(query)

  useEffect(() => {
    if (!isEmpty(query) && query !== params) {
      getData()
    }
  }, [query]);

  useEffect(() => {
    getData()
  }, []);

  useEffect(() => {
    isReload && getData('', isReload)
  }, [isReload]);

  const getData = (value?, isReload = false): Promise<any> => {
    console.log('fetch----》', 'isCommon:', isCommon)
    console.log('fetch----》', 'isReload:', isReload, value)
    // console.log('fetch----》', isCommon , value , isEmpty(query))
    const rest = value || isReload ? {...fixedParams} : {...query, ...fixedParams}
    return fetchOptions({
      params: {pageId: 1, pageSize: props.pageSize || 10},
      data: {enabled, [nameKey]: value || undefined, ...rest}
    })
        .then((res: any) => {
          if (resDataIsArray&&res?.length) {
            return res.map(item => ({
              ...item,
              label: item[fieldNames?.label || 'name'],
              value: item[fieldNames?.value || 'id'],
            }))?.filter(item => item.value)
          }
          const data = res.list?.map(item => ({
            ...item,
            label: item[fieldNames?.label || 'name'],
            value: item[fieldNames?.value || 'id'],
          }))
          if (query?.id === '0') return [{label: '通用', value: '0'}]
          if (isCommon && !value && isEmpty(query)) return [{label: '通用', value: '0'}, ...data]
          return data
        })
        .then((newOptions) => {
          setOptions(newOptions);
          setFetching(false);
        });
  }

  const debounceFetcher = useMemo(() => {
    const loadOptions = (value: string) => {
      setOptions([]);
      setFetching(true);
      getData(value)
    };
    return debounce(loadOptions, debounceTimeout);
  }, [debounceTimeout, isCommon, fixedParams]);

  const onChange = (v, option) => {
    console.log(v, typeof v, !v)
    props.onChange?.(props.mode ? v?.map(item => item.value) : v?.value, option)
    if(!v) {setIsReload(true)}
    if(props.mode && v.length <= 0) getData()
  }

  // console.log('options--->', options, props.value)

  return (<>
    {props?.readOnly ? <div>{options.find(item => item.value === props.value)?.label}</div> : <Select
        {...props}
        key={props.id}
        labelInValue
        allowClear
        showSearch
        placeholder={'请搜索选择' + label}
        filterOption={false}
        onSearch={debounceFetcher}
        notFoundContent={fetching ? <Spin size="small"/> : <div><Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/></div>}
        onChange={onChange}
        onBlur={() => {
          console.log('onBlur--->')
          return getData('', isReload)
        }}
        options={options}
    />}
  </>)
}

export default DebounceSelect

